export default "__VITE_ASSET__BVfN7Mwn__"